import type {
  MissingMonogramValuesPerConfig,
  MissingOptionsPerConfiguration,
  MissingOptionValuesPerConfiguration,
} from '@susu/custom-made/utils/preloadConfiguration/preloadConfiguration';

export enum actions {
  SET_SHOW_MISSING_FABRIC_MODAL = 'SET_SHOW_MISSING_FABRIC_MODAL',
  SET_SHOW_MISSING_OPTIONS_PANEL = 'SET_SHOW_MISSING_OPTIONS_PANEL',
  SET_OPTIONS_WITHOUT_SELECTION = 'SET_OPTIONS_WITHOUT_SELECTION',
  SET_MONOGRAMS_WITH_MISSING_SELECTION = 'SET_MONOGRAMS_WITH_MISSING_SELECTION',
  SET_MISSING_OPTION_VALUES_PER_CONFIG = 'SET_MISSING_OPTION_VALUES_PER_CONFIG',
  SET_MISSING_MONOGRAM_VALUES_PER_CONFIG = 'SET_MISSING_MONOGRAM_VALUES_PER_CONFIG',
  SET_MISSING_OPTIONS_PER_CONFIG = 'SET_MISSING_OPTIONS_PER_CONFIG',
  SET_IS_SUMMARY_VALIDATION_TRIGGERED = 'SET_IS_SUMMARY_VALIDATION_TRIGGERED',
}

export interface MissingSelectionValuesProps {
  showMissingFabricModal: boolean;
  showMissingOptionsPanel: boolean;
  monogramsIdsWithMissingSelection: number[];
  missingOptionValuesPerConfig: MissingOptionValuesPerConfiguration;
  missingMonogramValuesPerConfig: MissingMonogramValuesPerConfig;
  missingOptionsPerConfig: MissingOptionsPerConfiguration;
  isSummaryValidationTriggered: boolean;
}

export const initialState: MissingSelectionValuesProps = {
  showMissingFabricModal: false,
  showMissingOptionsPanel: false,
  monogramsIdsWithMissingSelection: [],
  missingOptionValuesPerConfig: {},
  missingMonogramValuesPerConfig: {},
  missingOptionsPerConfig: {},
  isSummaryValidationTriggered: false,
};

interface SetShowMissingFabricModal {
  type: actions.SET_SHOW_MISSING_FABRIC_MODAL;
  payload: boolean;
}

interface SetShowMissiongOptionsPanel {
  type: actions.SET_SHOW_MISSING_OPTIONS_PANEL;
  payload: boolean;
}

interface SetMonogramsWihtMissingSelection {
  type: actions.SET_MONOGRAMS_WITH_MISSING_SELECTION;
  payload: number[];
}

interface SetMissingOptionValuesPerConfig {
  type: actions.SET_MISSING_OPTION_VALUES_PER_CONFIG;
  payload: MissingOptionValuesPerConfiguration;
}

interface SetMissingMonogramValuesPerConfig {
  type: actions.SET_MISSING_MONOGRAM_VALUES_PER_CONFIG;
  payload: MissingMonogramValuesPerConfig;
}
interface SetMissingOptionsPerConfig {
  type: actions.SET_MISSING_OPTIONS_PER_CONFIG;
  payload: MissingOptionsPerConfiguration;
}

interface SetIsSummaryValidationTriggered {
  type: actions.SET_IS_SUMMARY_VALIDATION_TRIGGERED;
  payload: boolean;
}

export type MissingSelectionValuesTypes =
  | SetShowMissingFabricModal
  | SetShowMissiongOptionsPanel
  | SetMonogramsWihtMissingSelection
  | SetMissingOptionValuesPerConfig
  | SetMissingMonogramValuesPerConfig
  | SetMissingOptionsPerConfig
  | SetIsSummaryValidationTriggered;

export default function MissingSelectionValuesReducer(
  state: MissingSelectionValuesProps,
  action: MissingSelectionValuesTypes,
) {
  switch (action.type) {
    case actions.SET_SHOW_MISSING_FABRIC_MODAL:
      return {
        ...state,
        showMissingFabricModal: action.payload,
      };
    case actions.SET_SHOW_MISSING_OPTIONS_PANEL:
      return {
        ...state,
        showMissingOptionsPanel: action.payload,
      };
    case actions.SET_MONOGRAMS_WITH_MISSING_SELECTION:
      return {
        ...state,
        monogramsIdsWithMissingSelection: action.payload,
      };
    case actions.SET_MISSING_OPTION_VALUES_PER_CONFIG:
      return {
        ...state,
        missingOptionValuesPerConfig: action.payload,
      };
    case actions.SET_MISSING_MONOGRAM_VALUES_PER_CONFIG:
      return {
        ...state,
        missingMonogramValuesPerConfig: action.payload,
      };
    case actions.SET_MISSING_OPTIONS_PER_CONFIG:
      return {
        ...state,
        missingOptionsPerConfig: action.payload,
      };
    case actions.SET_IS_SUMMARY_VALIDATION_TRIGGERED:
      return {
        ...state,
        isSummaryValidationTriggered: action.payload,
      };
    default:
      return state;
  }
}
